module.exports = __webpack_public_path__ + "img/piveau-logo-white.73e94a9c.svg";